/**
 * Vista: Lista de Encuestas de Satisfacción
 * Formato: AMX-VTA-FR-08
 */

import ventasService from '../services/ventas.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Encuestas de Satisfacción</h2>
          ${permisos.canCreate('encuestas_satisfaccion') ? `
            <button class="btn btn-primary" onclick="router.navigate('/ventas/encuestas/nueva')">
              + Nueva Encuesta
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas rápidas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Encuestas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPromedio" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Promedio General</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statMes" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Este Mes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statRecomendarian" style="font-size: 1.5rem; font-weight: bold; color: var(--primary);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Recomendarían %</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Usuario, Modelo..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Marca</label>
            <select id="marcaFilter" class="form-input">
              <option value="">Todas</option>
              <option value="LOVOL">LOVOL</option>
              <option value="MAQMUT">MAQMUT</option>
              <option value="AOSHENG">AOSHENG</option>
              <option value="BEE MACH">BEE MACH</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.encuestasListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Usuario</th>
                <th class="tbl-hide-mobile">Marca</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="encuestasTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando encuestas...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('encuestas_satisfaccion')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.encuestasListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarEncuestas();
      }, 500);
    });

    document.getElementById('marcaFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.marca;
      } else {
        this.filters.marca = e.target.value;
      }
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    await this.cargarEstadisticas();
    await this.cargarEncuestas();
  },

  async cargarEstadisticas() {
    try {
      const response = await ventasService.obtenerEstadisticasEncuestas();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statPromedio').textContent = stats.promedio_general ? stats.promedio_general.toFixed(1) : '-';
      document.getElementById('statMes').textContent = stats.este_mes || 0;
      document.getElementById('statRecomendarian').textContent = stats.porcentaje_recomendarian ? stats.porcentaje_recomendarian + '%' : '-';
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarEncuestas() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await ventasService.listarEncuestas(params);
      // La respuesta viene como { data: { encuestas: [], pagination: {} } }
      const data = response.data || response;
      const encuestas = data.encuestas || [];
      const pagination = data.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderEncuestas(Array.isArray(encuestas) ? encuestas : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar encuestas');
      console.error('Error:', error);
      this.renderEncuestas([]);
    }
  },

  renderEncuestas(encuestas) {
    const tbody = document.getElementById('encuestasTableBody');

    if (!encuestas || encuestas.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron encuestas
          </td>
        </tr>
      `;
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const estadoBadge = (e) => `<span class="badge ${e.completada ? 'badge-success' : 'badge-warning'}">${e.completada ? 'Completada' : 'Pendiente'}</span>`;
    const acciones = (e) => e.completada
      ? (permisos.canView('encuestas_satisfaccion') ? `<button class="btn btn-sm btn-primary" onclick="window.encuestasListView.verDetalle(${e.id})">Ver</button>` : '')
      : `${permisos.canEdit('encuestas_satisfaccion') ? `<button class="btn btn-sm btn-primary" onclick="window.encuestasListView.verDetalle(${e.id})">Editar</button>` : ''}
         ${permisos.canDelete('encuestas_satisfaccion') ? `<button class="btn btn-sm btn-danger" onclick="window.encuestasListView.eliminarEncuesta(${e.id})">Eliminar</button>` : ''}`;

    tbody.innerHTML = encuestas.map(e => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.encuestasListView.toggleRow(${e.id})">&#9654;</button>
        </td>
        <td><strong>${e.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaFmt(e.fecha_evaluacion)}</td>
        <td class="tbl-hide-mobile">${e.usuario || '-'}</td>
        <td class="tbl-hide-mobile">${e.marca || '-'}</td>
        <td class="tbl-hide-mobile">${e.modelo || '-'}</td>
        <td class="tbl-hide-mobile">${estadoBadge(e)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(e)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-enc-${e.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaFmt(e.fecha_evaluacion)}</dd>
            <dt>Usuario</dt><dd>${e.usuario || '-'}</dd>
            <dt>Marca</dt><dd>${e.marca || '-'}</dd>
            <dt>Modelo</dt><dd>${e.modelo || '-'}</dd>
            <dt>Estado</dt><dd>${estadoBadge(e)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(e)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  getCalificacionBadge(calificacion) {
    if (calificacion >= 4) return 'badge-success';
    if (calificacion >= 3) return 'badge-warning';
    return 'badge-danger';
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.encuestasListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.encuestasListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.encuestasListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarEncuestas();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('marcaFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarEncuestas();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-enc-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  verDetalle(id) {
    router.navigate(`/ventas/encuestas/${id}`);
  },

  async eliminarEncuesta(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar esta encuesta? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await ventasService.eliminarEncuesta(id);
          toast.success('Encuesta eliminada exitosamente');
          this.cargarEncuestas();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar encuesta');
          console.error(error);
        }
      }
    );
  }
};
